import { gtmSendEvent } from "@wojo/analytics";
import { Button, Modal, Text } from "@wojo/ui";
import { QRCodeSVG } from "qrcode.react";
import React from "react";
import styles from "./PushToAppModal.module.scss";
import Link from "next/link";

export type PushToAppModalProps = {
    learnMoreUrl: string;
    qrCodeLink: string;
    qrCodeAltText: string;
    title: string;
    subTitle: string;
    primaryButtonText: string;
    isOpen: boolean;
    onClose: () => void;
    tourCode?: string;
};

export const PushToAppModal: React.FC<PushToAppModalProps> = (props) => {
    const {
        learnMoreUrl,
        qrCodeLink,
        qrCodeAltText,
        title,
        subTitle,
        primaryButtonText,
        isOpen,
        onClose,
        tourCode,
    } = props;

    const svg = (
        <QRCodeSVG
            // In an ideal world, `title` would able to be set here or included as a child.
            // that option is in the trunk of the qrcode.react library, but not yet released.
            aria-label={qrCodeAltText}
            role="img"
            value={qrCodeLink}
            size={120}
            style={{
                justifySelf: "center",
            }}
            bgColor={"#fff"}
            fgColor={"var(--g-color-primary-500)"}
        />
    );

    return (
        <Modal
            isOpen={isOpen}
            onCloseRequested={onClose}
            accessibleTitle={title}
        >
            <div className={styles["outer-container"]}>
                <div className={styles["qr-and-text"]}>
                    {svg}
                    <div className={styles["text"]}>
                        <Text.Heading order="3" tag="h1">
                            {title}
                        </Text.Heading>
                        <Text.Body>{subTitle}</Text.Body>
                    </div>
                </div>
                <div className={styles["line"]}></div>
                <div className={styles["buttons"]}>
                    <Button
                        href={learnMoreUrl}
                        variant="primary"
                        tag={Link}
                        onClick={() =>
                            gtmSendEvent({
                                event: "track",
                                ga4Tracking: {
                                    ga4_object: "APP_MESSAGING",
                                    ga4_action: "CLICKED",
                                    clickText: primaryButtonText,
                                    destinationUrl: learnMoreUrl,
                                    tourCode: tourCode ?? "",
                                },
                            })
                        }
                    >
                        {primaryButtonText}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
